import { render, staticRenderFns } from "./AddDirectTax.vue?vue&type=template&id=2e3f2ca5"
import script from "./AddDirectTax.vue?vue&type=script&lang=js"
export * from "./AddDirectTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports